module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=FJ - Fiji.db7ea2f2.svg";